// import { TablePaginationFooter } from "../../../CommonComponents/TablePaginationFooter";
import FilterModal from "../FilterModal/FilterModal";
import styles from "./report.module.css";
import { useState } from "react";

const Report = () => {
  // > API request to /get-transaction-report
  const [searchQuery, setSearchQuery] = useState("");

  const reports = [
    "2025-01-28-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-27-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-26-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-25-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-24-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-23-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-22-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-21-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-20-100PAISA-TransactionAccount-Settement.zip",
    "2025-01-19-100PAISA-TransactionAccount-Settement.zip",
  ];

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    year: "",
    month: "",
  });

  const handlePaginationChange = (page, rowsPerPage) => {
    setCurrentPage(page);
    setItemsPerPage(rowsPerPage);
  };

  const filteredReports = reports.filter((file) => {
    const yearMatch = !filters.year || file.startsWith(filters.year);
    const monthMatch =
      !filters.month || file.includes(`-${filters.month.padStart(2, "0")}-`);
    const searchMatch =
      !searchQuery || file.toLowerCase().includes(searchQuery);
    return yearMatch && monthMatch && searchMatch;
  });

  const paginatedReports = filteredReports.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  const handleFilterClick = () => {
    setIsModalOpen(!isModalOpen); // Toggle modal visibility
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const applyFilters = (newFilters) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
    }));
    setCurrentPage(0);
  };

  const [selectedFilter, setSelectedFilter] = useState({
    year: "",
    month: "",
  });

  return (
    <div className={`${styles.root} mt-2`}>
      <section className={styles.transactionDataTable}>
        <div className={styles.top}>
          <div className={styles.reportHeader}>
            <h3 className={styles.latestAccountTransaction}>
              Latest Account Transaction Report
            </h3>
            <div className={styles.filter}>
              <div className={`${styles.textField}`}>
                <div className={`${styles.content} px-2`}>
                  <img
                    className={styles.leadingIcon}
                    alt=""
                    src="/leadingicon.svg"
                  />
                  <input
                    className={`${styles.filterLabel}`}
                    placeholder="Search..."
                    type="text"
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value.toLowerCase());
                      setCurrentPage(0);
                    }}
                  />
                </div>
              </div>
              {/* <ButtonWithIcon icon="filterlines.svg" text="Filter" /> */}
              <div
                className={`${styles.filterLinesParent} p-2 mx-2 position-relative mousePointer`}
                onClick={true ? handleFilterClick : (e) => e.preventDefault()} // Prevent click if disabled
              >
                <img
                  className={styles.filterLinesIcon}
                  alt=""
                  src="/filterlines.svg"
                />
                <div className={styles.input1}>Filter</div>
              </div>
              <div className="w-100 d-flex justify-content-end position-relative">
                {isModalOpen && (
                  <FilterModal
                    onClose={handleCloseModal}
                    page={"report"}
                    applyFilters={applyFilters}
                    selectedFilter={selectedFilter} // Pass selected filter
                    setSelectedFilter={setSelectedFilter} // Function to update filter
                  />
                )}
              </div>
              <div className={styles.reLoadTable}>
                <img
                  className={styles.reloadIcon}
                  loading="lazy"
                  alt=""
                  src="/reload.svg"
                />
              </div>
            </div>
          </div>
          <div className={styles.headerSeparator} />
        </div>

        <div className={styles.reportTable}>
          <div className={styles.tableHeader}>
            <div className={styles.cell}>File</div>
            <div className={styles.cell}>Download</div>
          </div>

          {paginatedReports.map((report, index) => (
            <div className={styles.tableRow} key={index}>
              <div className={styles.cell}>{report}</div>
              <div className={`${styles.cell} px-4`}>
                <img
                  src="/Download.svg"
                  alt="Download"
                  className={styles.downloadIcon}
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
        {/* <TablePaginationFooter
          totalCount={reports.length}
          onPageChange={handlePaginationChange}
        /> */}
      </section>
    </div>
  );
};

// Helper Components
const ButtonWithIcon = ({ icon, text }) => (
  <div className={styles.filterLinesParent}>
    <img className={styles.filterLinesIcon} alt="" src={`/${icon}`} />
    <div className={styles.labelText}>{text}</div>
  </div>
);

const HeaderAction = ({ text }) => (
  <div className={styles.headerAction}>
    <a className={styles.file}>{text}</a>
  </div>
);

export default Report;
